// reactstrap components
import { Container, Row } from "reactstrap";
// core components
import Header from "../../components/Headers/Header.js";
import UserList from "../../components/UserList";

const AdminIndex = () => {
  return (
    <>
      <Header
        title="Welcome"
        description="This is the admin dashboard. You can manage the users and their surveys here."
      />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <UserList />
          </div>
        </Row>
      </Container>
    </>
  );
};

export default AdminIndex;
